<template>
  <div class="dropdown auto-complete">
    <form>
      <div class="input-group">
        <input type="text" v-model="query" class="form-control" :placeholder="placeholder"
               @input="onChange" @focus="onFocus" @keydown.down="onArrowDown" @keydown.up="onArrowUp" @keydown.enter.prevent="onEnter"/>

        <span class="auto-complete-prefix mdi mdi-magnify"></span>
        <span class="auto-complete-suffix mdi mdi-close" v-if="clearButtonVisible()" @click="onClearInput"></span>
      </div>
    </form>

    <ul v-show="isOpen" class="dropdown-menu show">
      <li class="loading dropdown-item" v-if="isLoading">
        Otsime..
      </li>
      <template v-else>
        <li v-show="!results.length" class="dropdown-item">Ei leitud..</li>
        <li v-for="(result, i) in results" :key="i" @click.prevent="setResult(result)"
            class="dropdown-item"
            :class="{ 'active': i === arrowCounter }">
          <i class="mdi mdi-magnify" v-if="lastResultVisible()"></i>
          {{ renderLine(result) }}
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'AutoComplete',

    props: {
      getData: {
        type: Function,
        required: true
      },
      itemText: {
        type: Function,
        required: true
      },
      result: {
        type: Function,
        required: true
      },
      resultCleared: {
        type: Function,
        required: false
      },
      placeholder: {
        type: String,
        required: false,
        default: ''
      },
      minSymbols: {
        type: Number,
        required: false,
        default: 3
      },
      keepLastQuery: {
        type: Boolean,
        required: false,
        default: false
      },
      debounceDelay: {
        type: Number,
        required: false,
        default: 200
      },
      prefill: {
        type: String,
        required: false
      }
    },

    data() {
      return {
        isOpen: false,
        results: [],
        query: '',
        isLoading: false,
        arrowCounter: 0,
        debounceTimer: null,
        lastResults: [],
      };
    },

    methods: {

      onClearInput() {
        this.query = ''
        this.onChange({}, 0)
      },

      onChange(evt, noDebounce) {
        if (!this.query) {
          this.resultCleared && this.resultCleared()
        }

        if (!this.query || this.query.length < this.minSymbols) {
          this.hideResult()
          return
        }

        clearTimeout(this.debounceTimer)

        this.debounceTimer = setTimeout(() => {
          this.isLoading = true;

          this.getData(this.query).then(r => {
            this.isLoading = false;
            this.results = r;
            this.showResult()
          })

        }, noDebounce ? 0 : this.debounceDelay)
      },

      renderLine(data) {
        return this.itemText(data)
      },

      showResult() {
        this.isOpen = true
      },

      hideResult() {
        this.isOpen = false
      },

      onFocus() {
        if (this.query)
          this.onChange({}, true)
        else
          this.showLastResult()
      },

      showLastResult() {
        if (!this.lastResults.length) return
        this.results = this.lastResults
        this.showResult()
      },

      lastResultVisible() {
        return this.lastResults === this.results
      },

      rememberLastResult(item) {
        if (this.lastResults.find(r => r.id === item.id)) return
        this.lastResults.push(item)
        if (this.lastResults.length > 10) this.lastResults.shift()
      },

      setResult(item) {
        this.hideResult()
        this.query = this.keepLastQuery ? this.itemText(item) : '';
        this.result(item)
        this.rememberLastResult(item)
      },

      onArrowDown(evt) {
        if (this.arrowCounter < this.results.length) {
          this.arrowCounter = this.arrowCounter + 1;
        }
      },

      onArrowUp() {
        if (this.arrowCounter > 0) {
          this.arrowCounter = this.arrowCounter - 1;
        }
      },

      onEnter() {
        let item = this.results[this.arrowCounter]
        if (!item) return
        this.setResult(item)
        this.arrowCounter = -1;
      },

      handleClickOutside(evt) {
        if (!this.$el.contains(evt.target)) {
          this.hideResult()
          this.arrowCounter = -1;
        }
      },

      clearButtonVisible() {
        return !!this.resultCleared
      },

    },
    created() {
      this.query = this.prefill
    },
    mounted() {
      document.addEventListener('click', this.handleClickOutside)
    },
    destroyed() {
      document.removeEventListener('click', this.handleClickOutside)
    }
  };
</script>
